export default "__VITE_ASSET__DJtWD2n1__"